export const activeDrawer = (state) => state.activeDrawer;
